import script from "./TiktokTagDeleteDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TiktokTagDeleteDialog.vue?vue&type=script&setup=true&lang=js"

import "./TiktokTagDeleteDialog.vue?vue&type=style&index=0&id=2f11b32e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f11b32e"]])

export default __exports__